import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "addRouteInner" }
const _hoisted_2 = { class: "h5" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "alertBox"
}
const _hoisted_5 = {
  key: 0,
  class: "alertBoxTitle"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "buttonsWrapper" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "apiError" }

import {
  computed, ref, Ref, watchEffect,
} from 'vue';
import { Button, Spinner } from '../../Atoms';
import { RouteSubscription } from '../RouteSubscription';
import { markdownToHtml, validateSubscription } from '../../helpers';
import { RouteDetail, SmsErrors } from '../../types';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddRouteSubscription',
  props: {
    howItWorksTitle: {},
    howItWorksDescriptionMarkdown: {},
    startDate: { default: undefined },
    endDate: { default: undefined },
    textCode: { default: undefined },
    routes: {},
    alertTitle: {},
    alertDescriptionMarkdown: {},
    isLoading: { type: Boolean, default: false },
    apiError: {}
  },
  emits: ["save", "cancel", "updateStartDate", "updateEndDate", "updateTextCode"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const dirty = ref(false);
const errors: Ref<SmsErrors> = ref({
  textCode: false,
  rangeError: false,
});

const showAlert = computed(() => props.alertTitle || props.alertDescriptionMarkdown);
const howItWorksDescription = computed(() => markdownToHtml(props.howItWorksDescriptionMarkdown));
const alertDescription = computed(() => markdownToHtml(props.alertDescriptionMarkdown));

watchEffect(() => {
  errors.value = validateSubscription({
    startDate: props.startDate,
    endDate: props.endDate,
    textCode: props.textCode,
  });
});

const isError = computed(() => Object.values(errors.value).some((error) => error));
const handleUpdateStartDate = (date: string) => {
  emit('updateStartDate', date);
};

const handleUpdateEndDate = (date: string) => {
  emit('updateEndDate', date);
};

const handleUpdateRoute = (value: string) => {
  emit('updateTextCode', value);
};

const handleSave = () => {
  dirty.value = true;

  if (isError.value) {
    return;
  }
  emit('save');
  dirty.value = false;
};

const handleCancel = () => {
  dirty.value = false;
  emit('cancel');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.howItWorksTitle), 1),
    (howItWorksDescription.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "content",
          innerHTML: howItWorksDescription.value
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    (showAlert.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.alertTitle)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.alertTitle), 1))
            : _createCommentVNode("", true),
          (alertDescription.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "alertBoxContent",
                innerHTML: alertDescription.value
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_unref(RouteSubscription), {
        mode: 'new',
        routes: _ctx.routes,
        "text-code": _ctx.textCode,
        "range-error": errors.value.rangeError && dirty.value,
        "route-error": errors.value.textCode && dirty.value,
        "start-date": _ctx.startDate,
        "end-date": _ctx.endDate,
        onUpdateStartDate: handleUpdateStartDate,
        onUpdateEndDate: handleUpdateEndDate,
        onUpdateRoute: handleUpdateRoute
      }, null, 8, ["routes", "text-code", "range-error", "route-error", "start-date", "end-date"]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(Button), {
          type: "button",
          label: _ctx.$t('Cancel'),
          secondary: true,
          "on-click": handleCancel
        }, null, 8, ["label"]),
        _createVNode(_unref(Button), {
          type: "button",
          label: _ctx.$t('Save'),
          disabled: _ctx.isLoading,
          "on-click": handleSave
        }, {
          default: _withCtx(() => [
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_unref(Spinner), {
                  key: 0,
                  class: "spinner"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label", "disabled"])
      ])
    ]),
    (_ctx.apiError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.apiError), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})